<template>
  <div class="home">
        <div class="top">
            <span class="icon"
                    @click="goHistory"><img class="goHistory"
                    src="@/assets/image/08.png"
                    alt=""></span>
            <span class="iconText">写作指导</span>
        </div>
        <div class="content">

        </div>
  </div>
</template>

<script>
export default {
    name: 'WritingGuideDetail',
    data () {
        return {

        }
    },
    mounted(){

    },
    methods:{
        goHistory(){
            this.$router.push({name: 'WritingGuide'})
        }
    }
}
</script>

<style lang="less" scoped>
.home{
    .top {
        height: 110px;
        background-color: #fff;
        position: relative;
        padding: 0 50px;
        .goHistory {
            width: 16px;
            height: 32px;
            cursor: pointer;
        }
        .icon {
            position: absolute;
            top: 50%;
            margin-top: -7px;
            left: 50px;
        }
        .iconText {
            position: absolute;
            top: 50%;
            margin-top: -10px;
            left: 100px;
            color: #9d9292;
            font-size: 24px;
        }
    }
    .content{
        background: #fff;
        width: 1240px;
        min-height: 500px;
        margin: 0 auto;
        margin-top: 20px;
    }
}
</style>
